'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _modalLocal = require('./modal.local.css');

var _modalLocal2 = _interopRequireDefault(_modalLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      closeModal = _ref.closeModal,
      closeButton = _ref.closeButton;
  return _react2.default.createElement('div', {
    className: _modalLocal2.default.header
  }, _react2.default.createElement('h4', {
    className: _modalLocal2.default.title
  }, children), closeButton && _react2.default.createElement(_button2.default, {
    className: _modalLocal2.default.closeButton,
    onClick: closeModal,
    theme: 'outline',
    color: 'grayscale',
    ariaLabel: 'Close'
  }, _react2.default.createElement(_icon2.default, {
    icon: 'close',
    color: 'currentColor',
    className: _modalLocal2.default.closeButtonIcon
  })));
};

ModalHeader.defaultProps = {
  closeButton: true
};
ModalHeader.propTypes = {
  children: _propTypes2.default.node,
  closeModal: _propTypes2.default.func.isRequired,
  closeButton: _propTypes2.default.bool
};
exports.default = ModalHeader;